import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { promiseWithLoaderAndMessages } from '../../../utilities';
import type { RootState } from '../../../app/rootReducer';
import queryable, { Query } from '../../../services/queryable';
import { ListReturnType } from '../../../services/queryable-base';
import { HeaderParams } from '../../../@types/headers';
import { Cultivar } from '../../../@types/estoque/item';
import CultivaresService from '../../../services/estoque/cultivares';
import { falhaAoCarregar } from '../../../utilities/default-confirmation-messages';

interface CultivaresState {
  cultivares: Cultivar[],
  pagination: HeaderParams,
}

const initialState: CultivaresState = {
  cultivares: [],
  pagination: {
    currentPage: undefined,
    totalRecords: undefined,
    maxPerPage: undefined,
    pages: undefined,
  },
};

export const fetchCultivares = createAsyncThunk<
  ListReturnType<Cultivar>,
  undefined | Omit<Query<Cultivar>, 'service'>
>(
  `${CultivaresService.endpoint}/list`,
  async (params = {}, { dispatch }) => {
    const query = queryable.query({
      ...params,
      service: CultivaresService,
    });

    return promiseWithLoaderAndMessages(
      dispatch,
      query,
      {
        errorMessage: falhaAoCarregar('cultivares'),
        withLoader: false,
      },
    );
  },
);

export const cultivaresSlice = createSlice({
  name: 'cultivar',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchCultivares.fulfilled, (state, { payload }) => {
      state.cultivares = payload.data;
      state.pagination = payload.headers;
    });
  },
});

export const selectCultivarState = (state: RootState) => state.cultivarReducer;

export default cultivaresSlice.reducer;
